import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, JoinColumn } from 'typeorm'

import Question from './Question'

export enum AssetType {
  IMAGE = 'image',
  URL = 'url'
}

@Entity('question_assets')
export default class QuestionAsset {
  @PrimaryGeneratedColumn()
  id!: number

  @ManyToOne(type => Question, question => question)
  @JoinColumn({ name: 'question_id' })
  question!: Question

  @Column({ type: 'enum', enum: AssetType })
  type!: AssetType

  @Column()
  url!: string

  @Column({ nullable: true })
  title?: string

  @Column({ name: 'force_open', default: () => false })
  forceOpen!: boolean
}
